<template>
  <b-modal
    :id="id"
    hide-header-close
    no-close-on-backdrop
    no-close-on-keyboard
    no-close-on-esc
    hide-footer
    :modal-class="modalClass"
  >
    <!-- HEADER -->
    <template #modal-header>
      <div class="w-100 d-flex align-items-center modal-header-custom">

        <!-- Back / Close -->
        <i style="font-size: 16px !important;"
          class="fas fa-chevron-left back-icon"
          @click="$emit('close')"
        ></i>

        <!-- Parent Page -->
        <span class="parent-text">
          {{ parent }}
        </span>

        <span class="separator">›</span>

        <!-- Current Page -->
        <span class="current-text">
          <i style="font-size: 16px !important;" :class="icon" class="current-icon"></i>
          {{ title }}
        </span>

      </div>
    </template>

    <!-- BODY -->
    <slot />
  </b-modal>
</template>

<script>
export default {
  name: "DashboardModal",
  props: {
    id: { type: String, required: true },

    /* Current page */
    title: { type: String, required: true },
    icon: { type: String, required: true },

    /* Parent page */
    parent: { type: String, required: true },

    modalClass: { type: String, default: "usersListPendingFull" }
  }
}
</script>

<style scoped>
.modal-header-custom {
  font-size: 14px;
  font-weight: 600;
}

.back-icon {
  cursor: pointer;
  margin-right: 10px;
  color: #0d6efd;
}

.back-icon:hover {
  opacity: 0.7;
}

.parent-text {
  color: #0d6efd;
}

.separator {
  margin: 0 8px;
  color: #6c757d;
}

.current-text {
  color: #212529;
  display: flex;
  align-items: center;
}

.current-icon {
  margin-right: 6px;
  font-size: 14px;
}
</style>
